export const canBTCFlowToFoxbit = () => {
    const secret = new URLSearchParams(window.location.search).get('secret');

    if (secret === 'allow_btc_foxbit') {
        return true;
    }

    return Date.now() >= new Date('2025-12-17T15:30:00Z').getTime();
  };